const isIpv4Address = (value = "") => /^\d{1,3}(?:\.\d{1,3}){3}$/.test(String(value || ""));

export const isElectronRuntime = () => {
  if (typeof navigator === "undefined") return false;
  return String(navigator.userAgent || "").toLowerCase().includes("electron");
};

export const isLoopbackHost = (hostname = "") => {
  const host = String(hostname || "").toLowerCase();
  return host === "localhost" || host === "127.0.0.1" || host === "::1" || host === "[::1]";
};

export const isPrivateLanHost = (hostname = "") => {
  const host = String(hostname || "").trim();
  if (!isIpv4Address(host)) return false;
  const [a, b] = host.split(".").map((part) => Number.parseInt(part, 10));
  return (
    a === 10 ||
    (a === 192 && b === 168) ||
    (a === 172 && b >= 16 && b <= 31) ||
    (a === 169 && b === 254)
  );
};

export const isCloudHost = (hostname = "") => {
  const host = String(hostname || "").toLowerCase();
  if (!host) return false;
  if (isLoopbackHost(host) || isPrivateLanHost(host)) return false;
  if (host.includes("moosync")) return true;
  return !host.endsWith(".local");
};

export const isLocalLanRuntime = () => {
  if (typeof window === "undefined") return false;
  const host = window.location?.hostname || "";
  return isElectronRuntime() || isLoopbackHost(host) || isPrivateLanHost(host);
};

export const shouldEnableLocalOfflineSupport = () => {
  if (typeof window === "undefined") return false;
  if (!isLocalLanRuntime()) return false;
  if (typeof navigator === "undefined" || !("serviceWorker" in navigator)) return false;
  return Boolean(window.isSecureContext || isLoopbackHost(window.location?.hostname || ""));
};
